import { useLanguage } from '../contexts/LanguageContext';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons';

const LockedContent: React.FC = () => {
  const { translations } = useLanguage();

  return (
    <div className='no-requests locked-content'>
      <FontAwesomeIcon icon={faLock} className='empty-icon locked-icon'/><br />
      <div className='login-text'>{translations.requireslogin}</div>
      <Link to="/login">
        <span>{translations.login}</span>
      </Link>
    </div>
  );
}

export default LockedContent;